var _defs, _circle, _circle2, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlnMark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    role: "img",
    "aria-label": "Great Leaders Network",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "glnDisc",
    x1: "20%",
    y1: "10%",
    x2: "85%",
    y2: "92%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5248a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45%",
    stopColor: "#433984"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#322e6a"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 94,
    fill: "url(#glnDisc)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 94,
    fill: "none",
    stroke: "#ffc915",
    strokeWidth: 6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#94b0dd",
    strokeOpacity: 0.38,
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 52 L100 34 L158 52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 148 L100 166 L158 148"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 34,
    r: 3.1,
    fill: "#ffc915"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 52,
    r: 2.6,
    fill: "#ffc915"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 52,
    r: 2.6,
    fill: "#ffc915"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 148,
    r: 2.5,
    fill: "#cedbe6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 148,
    r: 2.5,
    fill: "#cedbe6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 166,
    r: 2.8,
    fill: "#94b0dd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 11,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.5 85.7A25 25 0 1 1 75.5 114.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 100 H80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97 76 V124 H122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 124 V76 L166 124 V76"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlnMark);
export default __webpack_public_path__ + "static/media/gln-mark.99bce770ae630f22c40cb8fc0ecb37e8.svg";
export { ForwardRef as ReactComponent };